import React from "react";
import { Form, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FetchSelectedList } from "../../services/selectedService";
import api from "../../api";
import { UpdateDetails } from "../../services/commonService";
import { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ConfirmationModal from "../Pending_Application/ConfirmationModal";
import UpdationModal from "../Pending_Application/UpdationModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import action2 from "../../assets/images/icon/action_2.svg";
import action3 from "../../assets/images/icon/action_3.svg";
import { CSVLink } from "react-csv";
import { Button, Spinner } from "reactstrap";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import cross from "../../assets/images/icon/cross.svg";
import name_icon from "../../assets/images/icon/name01.svg";
import job from "../../assets/images/icon/job-port.svg";
import education from "../../assets/images/icon/education-role.svg";
import star_exp from "../../assets/images/icon/exp_job.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import selected_icon from "../../assets/images/icon/selected2.png";
import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import { getUserToken } from "helpers/authHelper";
import { getRemarks } from "helpers/backend_helper";
import {
  updatestatus,
  FetchFilterInfo,
  getFilteredList,
} from "services/pendingService";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getDeviceInfo,
  useDebounce,
  getSubdomain
} from "helpers/utils";
import { getFilterStatus } from "helpers/common";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Trans, useTranslation } from "react-i18next";
import moment from "moment";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";

function SelectedList(props) {
  const getDashboardFilterData = key => {
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (!key || !payloadObj?.filterValue) {
      return;
    }
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    return dashboardFilters?.[key] || "";
  };
  const { t } = useTranslation();
  const [selectedData, setSelectedData] = useState([]);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUpdationModal, setShowUpdationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedApplId, setSelectedApplId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDOB, setSelectedDOB] = useState(null);
  const [selectedUserID, setSelectedUserID] = useState(null);

  //filter initilization
  const [testStatus, setTestStatus] = useState("");
  const [interviewStatusFilter, setInterviewStatusFilter] = useState("");
  const [offerLetterStatus, setOfferLetterStatus] = useState("");
  const [isReject, setIsReject] = useState(false);
  const testtatusOptions = getFilterStatus(1);
  const interviewStatusOptions = getFilterStatus(2);
  const offerLetterOptions = [
    { value: "0", label: t(`ATS View.Pending`) },
    { value: "1", label: t(`ATS View.Approved`) },
    { value: "2", label: t(`ATS View.Rejected`) },
  ];

  const [roleTypes, setRoleTypes] = useState([]);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState([]);
  const [gender, setGender] = useState("");
  const [sourceType, setSourceType] = useState([]);
  const [source, setSource] = useState("");
  const [onboarding, setOnboarding] = useState("");
  const [regions, setRegions] = useState([]);
  const [states, setStates] = useState([]);
  const [region, setRegion] = useState("");
  const [state, setState] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState(
    getDashboardFilterData("startDate")
      ? new Date(getDashboardFilterData("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    getDashboardFilterData("endDate")
      ? new Date(getDashboardFilterData("endDate"))
      : ""
  );
  const [type, setType] = useState(getDashboardFilterData("type") || "");
  const [query, setQuery] = useState("");
  const [isComment, setIsComment] = useState(false);
  const [isFeedback, setIsFeedback] = useState(false);
  const [csvData, setCSVData] = useState([]);
  const history = useHistory();
  const STATUS_MAP = {
    reject: { code: 5, label: "Rejected" },
    shortlist: { code: 1, label: "Shortlisted" },
    selectcandidate: { code: 3, label: "Selected" },
    hold: { code: 4, label: "Onhold" },
  };
  const [actionType, setActionType] = useState("reject");
  const [remarks, setRemarks] = useState([]);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [formData, setFormData] = useState({
    board_addr: "",
    board_date: "",
    board_time: "",
    onboard_documents: "",
  });

  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const convertDateFormat = dateString => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isReject && actionType === "reject") {
      fetchRemarks();
    } else {
      // reset when switching action
      setRemarks([]);
      setSelectedRemark(null);
      setComment("");
      setCommentError("");
    }
  }, [isReject, actionType]);

  const handleRemarkChange = e => {
    const remarkId = e.target.value;
    const remark = remarks.find(r => r.id == remarkId);

    setSelectedRemark(remark);

    // Optional: auto-fill comment
    // setComment(remark?.remark_label || "");
  };

  const fetchRemarks = async () => {
    try {
      const res = await getRemarks("reject");
      console.log(res.data, "Remarks");
      setRemarks(res.data); // or res.data.data (check API)
    } catch (err) {
      console.error(err);
    }
  };

  const handleActionSubmit = () => {
    if (!STATUS_MAP[actionType]) {
      console.error("Invalid action type:", actionType);
      return;
    }

    const trimmedComment = comment.trim();

    if (actionType === "reject") {
      if (!selectedRemark) {
        setCommentError("Please select rejection reason");
        return;
      }

      if (selectedRemark.is_comment_required && !trimmedComment) {
        setCommentError("Comment is required");
        return;
      }
    }

    if (actionType !== "reject" && isCommentRequired && !trimmedComment) {
      setCommentError("Comment is required");
      return;
    }

    setCommentError("");

    handleConfirm(
      candidateDetails.appl_id,
      STATUS_MAP[actionType].code,
      trimmedComment,
      STATUS_MAP[actionType].label,
      selectedRemark?.id || null
    );
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Validate int_schedule_date
    if (!formData.board_addr) {
      newErrors.board_addr = t(`all-application.Onboarding Address required`);
      valid = false;
    }

    // Validate int_schedule_time
    if (!formData.board_date) {
      newErrors.board_date = t(`all-application.Onboarding Date required`);
      valid = false;
    }

    // Validate interview_title
    if (!formData.board_time) {
      newErrors.board_time = t(`all-application.Onboarding Time required`);
      valid = false;
    }

    // Validate interviewer_time
    // if (!formData.onboard_documents) {
    //   newErrors.onboard_documents = "Onboarding Document is required";
    //   valid = false;
    // }
    setErrors(newErrors);
    return valid;
  };

  const reject_close = () => {
    setIsReject(false);
    setCommentError("");
  };

  const handleOnboardInvite = async (e, appl_id) => {
    e.preventDefault();
    if (isLoading) return;

    if (!validateForm()) {
      return;
    } else {
      let newFormData = JSON.parse(JSON.stringify(formData));
      let device_info = await getDeviceInfo();
      const formattedDate = convertDateFormat(newFormData.board_date);
      newFormData.board_date = formattedDate;
      newFormData.old_status = "Selected Applications";
      newFormData.new_status = "Onboarded(Joined) Applications";
      newFormData.device_info = device_info;
      setIsLoading(true);
      try {
        await api.post(
          `${process.env.REACT_APP_API_URL}/admin/selected/invite-onboard/${appl_id}`,
          newFormData
        );
        toast.success(t(`all-application.Onboard Invite sent`));
      } catch (error) {
        console.error("Error submitting form:", error.message);
        toast.error(t(`all-application.Error submitting form`));
      } finally {
        setIsLoading(false);
      }
      getSelectedList();
      onboard_close();
    }
  };

  const handleCSVDownload = async e => {
    e.preventDefault();
    try {
      let csvData = [];
      if (isFiltered) {
        let payload = {
          type: "selected",
          gender: gender,
          role: selectedRoleOptions,
          onboarding: onboarding,
          source: source,
          region: region,
          state: state,
          city: city,
          area: area,
          startDate: startDate,
          endDate: endDate,
          testStatus: testStatus,
          interviewStatusFilter: interviewStatusFilter,
          offerLetterStatus: offerLetterStatus,
          pageSize: sizePerPage,
          page: currentPage,
          isCsvDownload: true,
        };
        csvData = await getFilteredList(payload);
      } else {
        csvData = await FetchSelectedList({
          page: currentPage,
          queryText: query,
          pageSize: sizePerPage,
          isCsvDownload: true,
        });
      }

      if (csvData.data.status) {
        csvData = csvData?.data?.data?.map(item => ({
          ...item,
          email_id: generateMaskedPII(item?.email_id),
          mobile: generateMaskedPII(item?.mobile, 2),
        }));
        setCSVData(csvData);
        setTimeout(() => {
          let element = document.getElementById("downloadCSV");
          element.click();
        }, 1000);
        toast.success("File downloaded successfully.");
        setLoading(false);
      } else {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      }
    } catch (err) {
      return [];
    }
  };
  const getSelectedList = async (current = 1, size = 10, query_text = "", sort_field = sortField, sort_order = sortOrder) => {
    setLoading(true);
    await FetchSelectedList({
      page: current,
      queryText: query_text,
      pageSize: size,
      ...(sort_field && { sortField: sort_field, sortOrder: sort_order }),
    })
      .then(res => {
        if (res.data.status) {
          setSelectedData(res.data.data);
          setTotalCounts(res.data?.total_counts);
          setLoading(false);
        } else {
          toast.error(t(`all-application.No data Available`));
          setLoading(false);
        }
      })
      .catch(err => {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      });
  };

  // Fetch Faqs listing data
  useEffect(() => {
    if (type) {
      handleSubmit();
    } else {
      getSelectedList(1, 10);
    }
    getFilterInfo();
    document.title = "NeuroTal - Selected Applications";
  }, []);

  const handleGenderChange = e => {
    if (gender === e.target.name) {
      setGender("");
    } else {
      setGender(e.target.name);
    }
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          setCities(filterData?.cities || []);
          setAreas(filterData?.areas || []);
          setRegions(filterData?.regions || []);
          setRoleTypes(filterData?.roles || []);
          setSourceType(filterData?.sources || []);
          setStates(filterData?.states || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const changeHandler = e => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const openModal = (message, appl_id, status) => {
    setShowModal(true);
    setModalMessage(message);
    setSelectedApplId(appl_id);
    setSelectedStatus(status);
  };
  const closeModal = () => {
    setShowModal(false);
    setModalMessage("");
    setSelectedApplId(null);
    setSelectedStatus(null);
  };

  const openUpdationModal = (message, user_id, dob, appl) => {
    setShowUpdationModal(true);
    setModalMessage(message);
    setSelectedApplId(appl?.appl_id);
    setSelectedUserID(user_id);
    setSelectedDOB(dob);
    setSelectedStatus(null);
  };

  const closeUpdationModal = () => {
    setShowUpdationModal(false);
    setModalMessage("");
    setSelectedApplId(null);
    setSelectedUserID(null);
    setSelectedDOB(null);
    setSelectedStatus(null);
  };

  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [isCommentRequired, setIsCommentRequired] = useState(false);
  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const validateComment = () => {
    // if (!comment.trim()) {
    //   setCommentError("Comment is required.");
    //   return false;
    // }
    // You can add more validation rules here if needed
    return true;
  };
  const toggleCommentRequirement = () => {
    setIsCommentRequired(prevIsCommentRequired => !prevIsCommentRequired);
  };

  const handleConfirm = async (
    appl_id,
    status,
    comment,
    new_status = "",
    remark_id = null
  ) => {
    if (isLoading) return;
    if (validateComment()) {
      let otherDetails = {};
      if (new_status) {
        otherDetails = {
          old_status: "Selected Applications",
          new_status: `${new_status} Applications`,
        };
      }
      setIsLoading(true);
      await updatestatus(appl_id, status, comment, 3, remark_id, otherDetails)
        .then(res => {
          if (res.status === 200) {
            if (status === 5) {
              toast.success(t(`all-application.Record Rejected`));
            } else if (status === 4) {
              toast.success(t(`all-application.Record Onhold`));
            } else {
              toast.success(t(`all-application.Comment Added`));
            }
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
      hold_close();
      closes();
      comment_close();
    } else {
      console.log("Validation error:", commentError);
    }
    getSelectedList();
    // window.location.reload();
  };

  const handleUpdation = (user_id, dob, amValues) => {
    let formData = new FormData();
    formData.append("dob", dob);

    UpdateDetails(user_id, formData)
      .then(res => {
        if (res.status === 200) {
          toast.success(t(`all-application.Details Edited`));
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
    getSelectedList();
    closeUpdationModal();
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allUsers = selectedData?.map(el => {
      if (el?.appl_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setSelectedData(allUsers);
  };

    function calculateDaysAgo(applyDate) {
    const applyDateObj = new Date(applyDate);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - applyDateObj;

    // Convert milliseconds to days (1000 ms in a second, 60 seconds in a minute, 60 minutes in an hour, 24 hours in a day)
    const daysAgo = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return daysAgo;
  }

  const cityColumn = {
  dataField: "master_city.city",
  text: t(`all-application.City`),
  classes: "application-normal",
};


  const columns = [
    {
      dataField: "appl_id",
      text: t(`all-application.Appl No`),
      classes: "total app-col sticky-col",
      headerClasses: "app-col sticky-col",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              id={`checkbox-input-${row?.appl_id}`} // Unique ID for the checkbox
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
              className="d-none"
            />
            <label htmlFor={`checkbox-input-${row?.appl_id}`}>
              {formattedDate}
            </label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`all-application.Name`),
      classes: "application-name name-col sticky-col",
      headerClasses: "name-col sticky-col",
      sort: true,
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell?.toLowerCase()}
        </span>
      ),
    },
 

    {
      dataField: "email_id",
      text: t(`all-application.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "mobile",
      text: t(`all-application.Mobile No`),
      classes: "application-normal",
      formatter: (cell, row) => <>{generateMaskedPII(row?.mobile, 2)}</>,
    },
    {
      dataField: "job_user.master_reference_table.gender",
      text: t(`all-application.Gender`),
      classes: "application-normal",
      formatter: (cell, row) => {
        return cell ? t(`Gender.${cell}`) : t("Gender.Unknown");
      },
    },

    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      classes: "application-normal educations",
      sort: true,
    },
    {
      dataField: "job_user.total_experience",
      text: t(`all-application.Total Exp`),
      classes: "application-normal",
      sort: true,
    },
    {
      dataField: "vacancy.title",
      text: t(`all-application.Job Role`),
      classes: "application-normal",
      sort: true,
    },
     {
      dataField: "vacancy.franchise.franchise_name",
   text: t(`all-application.dealer_name`),
      classes: "application-normal",
      sort: false,
    },
    ...(getSubdomain() !== "mahindra" ? [cityColumn] : []),
        {
      dataField: "apply_date",
      text: t(`all-application.Applied on`),
      classes: "application-normal",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const today = new Date();
        const isToday = applyDate.toDateString() === today.toDateString(); // Compare date parts only

        const daysAgo = calculateDaysAgo(applyDate);

        return (
          <div className="date-tabel">
            <label>
              {isToday
                ? t(`all-application.Today`)
                : `${daysAgo} ${t(`all-application.days ago`)}`}
            </label>
          </div>
        );
      },
    },
    {
      dataField: "creator.name",
      text: t(`all-application.created_by`),
      classes: "application-normal",
    },
    {
      dataField: "offer_status",
      text: t(`all-application.Offer Status`),
      classes: "application-normal",
      formatter: (cell, row) => {
        if (row.offer_letter != "") {
          switch (row.offer_status) {
            case "0":
              return t(`all-application.Offer Sent`);
            case "1":
              return t(`all-application.Offer Accepted`);
            case "2":
              return t(`all-application.Offer Rejected`);
            default:
              return t(`all-application.Unknown Offer Status`);
          }
        } else {
          return t(`all-application.Offer Not Sent`);
        }
      },
    },
    {
      dataField: "",
      text: t(`all-application.Status`),
      classes: "Status-normal",
      headerClasses: "Status-normal",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        let user_id = row?.user_id;
        let vacancy_id = row?.vacancyId;
        return (
          <div
            key={appl_id}
            className="action-application"
            title={`Please select ${t(
              `all-application.Status`
            )?.toLowerCase()}`}
          >
            <label
              id="select-status-label"
              htmlFor={`select-status-${appl_id}`}
              className="d-none" // If you want to hide the label visually but keep it accessible, you can use 'sr-only' class from Bootstrap
            >
              {t(`all-application.Selected`)}
            </label>

            <Select
              id={`select-status-${appl_id}`}
              className="w-100"
              placeholder={t(`all-application.Selected`)}
              options={statusUpdateOptions}
              onChange={e => handleStatusChange(e, appl_id)}
              isOptionDisabled={option => option?.disabled}
              tabIndex={1}
              aria-labelledby="select-status-label" // This points to the label element
            />
          </div>
        );
      },
    },
    {
      dataField: "",
      text: t(`all-application.Actions`),
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        let dob = row?.job_user?.dob;
        let user_id = row?.user_id;

        return (
          <div className="action-application">
            <div className="action-one filter">
              <label htmlFor="dropdown-basic" className="sr-only">
                {t("all-application.Actions")}
              </label>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={threedots} alt="Three Dots" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "view")}
                    href={"printpending-list/" + appl_id}
                  >
                    {t(`all-application.Print Report`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "view")}
                    href={"candidate_consolidate/view-details/" + appl_id}
                  >
                    {t(`all-application.View Details`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "edit")}
                    onClick={() => open_slider(appl_id, 5)}
                  >
                    {t(`all-application.Onboarding Invite`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "edit")}
                    onClick={() =>
                      openUpdationModal("Edit Details", user_id, dob, row)
                    }
                  >
                    {t(`all-application.Edit Details`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "create")}
                    onClick={() => open_slider(appl_id, 0)}
                  >
                    {t(`all-application.Add Comment`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("selected-list", "create")}
                    onClick={() => open_slider(appl_id, 8)}
                  >
                    {t(`all-application.Add Feedback`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];

  const handleStatusChange = async (e, appl_id) => {
    const action = e?.value;
    console.log(action, "action");
    if (action === "hold") {
      await handleConfirm(
        appl_id,
        STATUS_MAP.hold.code,
        "",
        STATUS_MAP.hold.label
      );
    } else if (["reject", "shortlist", "selectcandidate"].includes(action)) {
      open_slider(appl_id, STATUS_MAP[action].code, action);
    }
  };

  const statusUpdateOptions = [
    {
      label: (
        <>
          <img src={selected_icon} alt="Selected Icon" />{" "}
          {t(`all-application.Selected`)}
        </>
      ),
      value: "selected",
    },
    {
      label: (
        <>
          <img src={action2} alt="On Hold Icon" />{" "}
          {t(`all-application.On Hold`)}
        </>
      ),
      value: "hold",
      disabled: !checkPermissionStatus("selected-list", "onhold"),
    },
    {
      label: (
        <>
          <img src={action3} alt="Rejected Icon" />{" "}
          {t(`all-application.Rejected`)}
        </>
      ),
      value: "reject",
      disabled: !checkPermissionStatus("selected-list", "reject"),
    },
  ];

  ///reject popup

  const [isHold, setIsHold] = useState(false);
  const hold_close = () => {
    setIsHold(false);
    setCommentError("");
  };

  const closes = () => {
    setIsReject(false);
    setCommentError("");
  };
  const comment_close = () => {
    setIsComment(false);
    setCommentError("");
  };
  const feedback_close = () => {
    setIsFeedback(false);
  };
  const onboard_close = () => {
    setIsOnboard(false);
  };
  ///hold popup
  const [isOnboard, setIsOnboard] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({});
  console.log(candidateDetails);
  const open_slider = async (appl_id, status, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;

      if (data.status && data.data.length > 0) {
        setCandidateDetails(data.data[0]);
      } else {
        console.error("Invalid data format received from API:", data);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }

    // Set action type ONLY if provided
    if (type != null) {
      setSelectedApplId(appl_id);
      setActionType(type);
      setIsReject(true);
    } else {
      if (status == 1) {
        setIsHold(!isHold);
      } else if (status == 2) {
        setIsReject(!isReject);
      } else if (status == 5) {
        setIsOnboard(!isOnboard);
      } else if (status == 8) {
        setIsFeedback(!isFeedback);
      } else {
        setIsComment(!isComment);
      }
    }
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = selectedData.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (selectedData.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [selectedData.length]);

  const handleStateChange = e => {
    setCity("");
    setState(e.target.value);
    let cityList = cities?.filter(
      el => el?.state_id === parseInt(e.target.value)
    );
    setFilteredCities(cityList);
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleSubmit = (newState, defaultType) => {
    if (!newState) {
      setCurrentPage(1);
      setSizePerPage(10);
    }
    let payload = {
      type: "selected",
      queryText: query,
      gender: gender,
      role: selectedRoleOptions,
      onboarding: onboarding,
      source: source,
      region: region,
      state: state,
      city: city,
      area: area,
      testStatus: testStatus,
      interviewStatusFilter: interviewStatusFilter,
      offerLetterStatus: offerLetterStatus,
      pageSize: 10,
      page: 1,
    };
    if (defaultType || type) {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }
    if (defaultType === "current" || type === "current") {
      payload.startDate = moment().startOf("month").format();
      payload.endDate = moment().endOf("month").format();
      setStartDate(moment().startOf("month").toDate());
      setEndDate(moment().endOf("month").toDate());
    } else if (type === "previous") {
      const start = moment().subtract(3, "months").toDate();
      const end = new Date();
      payload.startDate = moment(start).toISOString();
      payload.endDate = moment(end).toISOString();
      setStartDate(start);
      setEndDate(end);
    }
    const effectiveSortField = newState?.sortField !== undefined ? newState.sortField : sortField;
    const effectiveSortOrder = newState?.sortOrder !== undefined ? newState.sortOrder : sortOrder;
    const finalPayload = {
      ...(newState || payload),
      ...(effectiveSortField && { sortField: effectiveSortField, sortOrder: effectiveSortOrder }),
    };
    getFilteredList(finalPayload)
      .then(res => {
        if (res.data.status) {
          setSelectedData(res.data.data);
          setTotalCounts(res.data.total_counts);
          setIsFiltered(true);
        } else {
          toast.error(t(`all-application.No data Available`));
        }
        close();
      })
      .catch(err => console.log(err));
  };

  const clearFilters = () => {
    setGender("");
    setSelectedRoleOptions([]);
    setOnboarding("");
    setArea("");
    setState("");
    setCity("");
    setStartDate("");
    setEndDate("");
    setSource("");
    setTestStatus("");
    setInterviewStatusFilter("");
    setCurrentPage(1);
    setSizePerPage(10);
    setIsVisible(false);
    getSelectedList();
    setIsFiltered(false);
    setType("");
  };

  const getFilterList = () => {
    let filterArray = [];

    // Gender filter
    if (gender) {
      filterArray.push({
        label: "Gender",
        value: gender,
        key: "gender",
      });
    }

    // Role filter
    if (selectedRoleOptions?.length > 0) {
      filterArray.push({
        label: "Job Position",
        value: selectedRoleOptions.map(item => item.label).join(", "),
        key: "role",
      });
    }

    // Test Status filter
    if (testStatus) {
      let statusLabel = testtatusOptions.find(
        el => el.value == testStatus
      )?.label;
      filterArray.push({
        label: "Test Status",
        value: statusLabel,
        key: "testStatus",
      });
    }

    // Interview Status filter
    if (interviewStatusFilter) {
      let statusLabel = interviewStatusOptions.find(
        el => el.value == interviewStatusFilter
      )?.label;
      filterArray.push({
        label: "Interview Status",
        value: statusLabel,
        key: "interviewStatus",
      });
    }

    // Source filter
    if (source) {
      let sourceLabel = sourceType.find(el => el.value == source)?.label;
      filterArray.push({
        label: "Source Type",
        value: sourceLabel,
        key: "source",
      });
    }

    // State filter
    if (state) {
      let stateLabel = states.find(el => el.value == state)?.label;
      filterArray.push({
        label: "State",
        value: stateLabel,
        key: "state",
      });
    }

    // City filter
    if (city) {
      let cityLabel = filteredCities.find(el => el.value == city)?.label;
      filterArray.push({
        label: "City",
        value: cityLabel,
        key: "city",
      });
    }

    // Date Range filter
    if (type) {
      filterArray.push({
        label: t("Date Range"),
        value:
          type === "current"
            ? t("Current Month")
            : type === "previous"
            ? t("Last 3 Months")
            : `${moment(startDate).format("DD MMM YYYY")} - ${moment(
                endDate
              ).format("DD MMM YYYY")}`,
        key: "type",
      });
    }

    // Offer Letter Status
    if (offerLetterStatus) {
      let statusLabel = offerLetterOptions.find(
        el => el.value === offerLetterStatus
      )?.label;
      filterArray.push({
        label: "Offer Letter Status",
        value: statusLabel,
        key: "offerLetterStatus",
      });
    }

    return filterArray;
  };

  // handleFilterRemove function
  const handleFilterRemove = key => {
    const newState = {
      type: "selected",
      queryText: query,
      gender,
      role: selectedRoleOptions,
      source,
      state,
      city,
      testStatus,
      interviewStatusFilter,
      offerLetterStatus,
    };

    let defaultType = type;

    switch (key) {
      case "gender":
        setGender("");
        newState.gender = "";
        break;

      case "role":
        setSelectedRoleOptions([]);
        newState.role = [];
        break;

      case "testStatus":
        setTestStatus("");
        newState.testStatus = "";
        break;

      case "interviewStatus":
        setInterviewStatusFilter("");
        newState.interviewStatusFilter = "";
        break;

      case "source":
        setSource("");
        newState.source = "";
        break;

      case "state":
        setState("");
        setCity("");
        newState.state = "";
        newState.city = "";
        break;

      case "city":
        setCity("");
        newState.city = "";
        break;

      case "type":
        setType("");
        setStartDate("");
        setEndDate("");
        defaultType = "";
        break;

      case "offerLetterStatus":
        setOfferLetterStatus("");
        newState.offerLetterStatus = "";
        break;
    }

    // Handle date range if type exists
    if (defaultType) {
      newState.startDate = startDate;
      newState.endDate = endDate;
    }

    // Get filtered data with updated filters
    handleSubmit(newState, defaultType);
    setCurrentPage(1);
  };

  ///modal
  const [isVisible, setIsVisible] = useState(false);

  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = isLang1OrLang2 ? 30 : 20; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = isLang1OrLang2 ? 30 : 20;
    } else if (window.innerWidth < 1280) {
      moveDistance = isLang1OrLang2 ? 60 : 50;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = 150; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth >= 1280) {
      // Adjust based on lang-1 or lang-2
      if (bodyClassList.contains("lang-1")) {
        moveDistance = 380; // For lang-1
      } else if (bodyClassList.contains("lang-2")) {
        moveDistance = 100; // For lang-2
      } else {
        moveDistance = 380; // Default for 1280px+
      }
    } else if (window.innerWidth >= 1152) {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    } else {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const handleTableChange = (type, { page, sizePerPage: ps, sortField: sf }) => {
    if (type === "sort") {
      const newOrder = sf === sortField
        ? (sortOrder === "asc" ? "desc" : "asc")
        : "asc";
      setSortField(sf);
      setSortOrder(newOrder);
      setCurrentPage(1);
      if (isFiltered) {
        handleSubmit({
          type: "selected",
          gender, role: selectedRoleOptions, onboarding, source, state, city, area,
          startDate, endDate, testStatus, interviewStatusFilter, offerLetterStatus,
          pageSize: ps || sizePerPage,
          page: 1,
          sortField: sf,
          sortOrder: newOrder,
        }, "");
      } else {
        getSelectedList(1, ps || sizePerPage, query, sf, newOrder);
      }
    } else {
      setCurrentPage(page);
      setSizePerPage(ps);
      if (isFiltered) {
        handleSubmit({
          type: "selected",
          gender, role: selectedRoleOptions, onboarding, source, state, city, area,
          startDate, endDate, testStatus, interviewStatusFilter, offerLetterStatus,
          pageSize: ps,
          page,
          ...(sortField && { sortField, sortOrder }),
        }, "");
      } else {
        getSelectedList(page, ps, query, sortField, sortOrder);
      }
    }
  };

  const handleSearch = async () => {
    handleSubmit();
    setCurrentPage(1);
  };
  if (!checkPermissionStatus("selected-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`all-application.Access denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <ConfirmationModal
        show={showModal}
        handleClose={closeModal}
        handleConfirm={handleConfirm}
        message={modalMessage}
        appl_id={selectedApplId}
        status={selectedStatus}
      />
      <UpdationModal
        show={showUpdationModal}
        handleUpdationClose={closeUpdationModal}
        handleUpdation={handleUpdation}
        message={modalMessage}
        user_id={selectedUserID}
        initialDOB={selectedDOB}
      />
      <div className="pending-list-page">
        <div className="tabbing-wrapper allap d-flex justify-content-between mt-2 mb-4 position-relative">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="left-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul
              className="tab-btn-wrapper d-flex align-items-center"
              ref={tabWrapperRef}
              style={{ transition: "transform 0.3s" }}
            >
              <li>
                <Link
                  to={`/all-applications${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="all-applications"
                >
                  {t(`all-application.All Applications`)}
                </Link>
              </li>
           
              <li>
                <Link
                  to={`/pending-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="pending-list"
                >
                  {t(`all-application.New Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/screening-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="screening-list"
                >
                  {t(`all-application.In Progress Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/selected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link active"
                  id="selected-list"
                >
                  {t(`all-application.Selected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onboarded-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onboarded-list"
                >
                  {t(`all-application.Onboarded Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onhold-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onhold-list"
                >
                  {t(`all-application.Onhold Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/rejected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="rejected-list"
                >
                  {t(`all-application.Rejected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/archive-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="archive-list"
                >
                  {t(`all-application.Archived Applications`)}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3 table-height">
                <div className="table-data-search">
                  <div className="total-record">
                    <h5>
                      {t(`all-application.Total Records`)}{" "}
                      <span>{totalCounts || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <SearchBar
                      onSearch={handleSearch}
                      title={t(`all-application.Search by mobile2`)}
                      placeholder={
                        t(`all-application.Search by mobile`).slice(0, 40) +
                        "..."
                      }
                      query={query}
                      setQuery={setQuery}
                    />
                    {checkPermissionStatus("selected-list", "downloadcsv") && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "appl_id",
                              label: t(`all-application.Application ID`),
                            },
                            {
                              key: "name",
                              label: t(`all-application.Name`),
                            },
                            {
                              key: "mobile",
                              label: t(`all-application.Mobile Number`),
                            },
                            {
                              key: "email_id",
                              label: t(`all-application.Email ID`),
                            },
                            {
                              key: "createdAt",
                              label: t(`all-application.Created Date`),
                            },
                            {
                              key: "f2f_address",
                              label: t(`all-application.Address`),
                            },
                          ]}
                          filename={`SelectedApplicationList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`all-application.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}

                    <div className="take-text filter" onClick={filter_icon}>
                      <h5>
                        <span>
                          <img src={filtericon} alt="filter icon" />
                        </span>
                        {t(`all-application.Filters`)}
                      </h5>
                    </div>

                    <div className="tale-text right-panel alapp arrow-btns">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="left-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                {getFilterList()?.length > 0 && (
                  <div className="selected-data-card length-selected-data allapp mb-4">
                    {getFilterList()?.map((el, index) => {
                      return (
                        <div className="select-para" key={index}>
                          <p className="mb-0">
                            <span className="selected-tag text-capitalize">
                              {el?.label} - {el?.value}
                            </span>
                            <button
                              className="remove-tag-button"
                              onClick={() => handleFilterRemove(el?.key)}
                            >
                              &times;
                            </button>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className="timeto-hire-card userlist pendiglist-cardss">
                  {loading && (
                    <div className="m-3 p-3 text-center">
                      <Spinner size={"lg"} />{" "}
                      <div>{t(`all-application.Loading`)}</div>
                    </div>
                  )}
                  {!loading && (
                    <div className="table-custome-class range-custome">
                      {selectedData.length > 0 ? (
                        <>
                          <div className="scroll-container">
                            <div
                              className={`table-pending-list ${
                                hasIdBelow10 ? "table-pending-list-height" : ""
                              }`}
                            >
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <RemotePagination
                                  keyField="appl_id"
                                  data={selectedData}
                                  columns={columns}
                                  page={currentPage}
                                  sizePerPage={sizePerPage}
                                  totalSize={totalCounts}
                                  onTableChange={handleTableChange}
                                  rowClasses={rowClasses}
                                  sortField={sortField}
                                  sortOrder={sortOrder}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{t(`all-application.Appl No`)}</th>
                              <th>{t(`all-application.Name`)}</th>
                              <th>{t(`all-application.Email Id`)}</th>
                              <th>{t(`all-application.Mobile No`)}</th>
                              <th>{t(`all-application.Gender`)}</th>
                              <th>{t(`all-application.Education`)}</th>
                              <th>{t(`all-application.Total Exp`)}</th>
                              <th>{t(`all-application.Job Role`)}</th>
                              <th>{t(`all-application.City`)}</th>
                              <th>{t(`all-application.Actions`)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="10" className="text-center">
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>{t(`all-application.No Item Found`)}</h3>
                                  <p>
                                    <Trans>
                                      {t(`all-application.No Item Msg`)}
                                    </Trans>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {isVisible && (
            <div className="filter-shadow filetr-cards">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Filters`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={close}>
                    <img src={cross} alt="cross icon" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="application-gender">
                  <h5>{t(`Bulk Import.Select Applicant Gender`)}</h5>

                  <div className="application-button">
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Male"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Male"}
                        />
                        <span>{t(`Gender.Male`)}</span>
                      </label>
                    </div>
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Female"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Female"}
                        />
                        <span>{t(`Gender.Female`)} </span>
                      </label>
                    </div>
                    <div class="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Other"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Other"}
                        />
                        <span>{t(`Gender.Other`)}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="filter-cards-form">
                  <form class="form-inline">
                    <div className="col-lg-12">
                      <label>{t(`ATS View.Select Job Position`)}</label>

                      <div
                        title={
                          selectedRoleOptions.length
                            ? `${selectedRoleOptions
                                .map(option => option.label || option.name)
                                .join(", ")}`
                            : `Please ${t("ATS View.Select Job Position")}`
                        }
                      >
                        <MultiSelect
                          options={roleTypes}
                          value={selectedRoleOptions}
                          onChange={setSelectedRoleOptions}
                          labelledBy="Select Job Position"
                          placeholder="Select"
                          overrideStrings={{
                            selectSomeItems: t("ATS View.Select Job Position"),
                          }}
                        />
                      </div>
                    </div>

                    {/* <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setOnboarding(e.target.value)}
                    aria-label="Default select example"
                    value={onboarding}
                  >
                    <option value="">Select Onboarding Status</option>
                    {OnboardingOptions?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div> */}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t(`ATS View.Select Source Type`)}</label>

                      <div
                        title={`${
                          source
                            ? sourceType.find(el => el.value == source)?.label
                            : t("ATS View.Select Source Type")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setSource(e.target.value)}
                          aria-label="Default select example"
                          value={source}
                        >
                          <option value="">
                            {t(`ATS View.Select Source Type`)}
                          </option>
                          {sourceType?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
                    {/* <div className="col-lg-12">
                    <Form.Select
                      onChange={(e) => setRegion(e.target.value)}
                      aria-label="Default select example"
                      value={region}
                    >
                      <option value="" >Select Region</option>
                      {regions?.map((el) => {
                        return <option value={el?.value}>{el?.label}</option>
                      })}
                    </Form.Select>
                  </div> */}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t(`ATS View.Select State`)}</label>

                      <div
                        title={`${
                          state
                            ? states.find(el => el.value == state)?.label
                            : t("ATS View.Select State")
                        }`}
                      >
                        <Form.Select
                          onChange={e => handleStateChange(e)}
                          aria-label="Default select example"
                          value={state}
                        >
                          <option value="">{t(`ATS View.Select State`)}</option>
                          {states?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t(`ATS View.Select City`)}</label>

                      <div
                        title={`${
                          city
                            ? filteredCities.find(el => el.value == city)?.label
                            : t("ATS View.Select City")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setCity(e.target.value)}
                          aria-label="Default select example"
                          value={city}
                        >
                          <option value="">{t(`ATS View.Select City`)}</option>
                          {filteredCities?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
                    {/* OfferLetter Status Dropdown */}
                    {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t(`ATS View.Select Offer Status`)}</label>

                      <div
                        title={`${
                          offerLetterStatus
                            ? offerLetterOptions.find(
                                el => el.value == offerLetterStatus
                              )?.label
                            : t("ATS View.Select Offer Status")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setOfferLetterStatus(e.target.value)}
                          aria-label="Offer Status"
                          value={offerLetterStatus} // Directly set to the selected value
                        >
                          <option value="">
                            {t(`ATS View.Select Offer Status`)}
                          </option>
                          {offerLetterOptions?.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>
                    )}
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="float-label">
                          {t(`all-application.Custom Date Range`)}
                        </Form.Label>
                        <div className="application-button mb-2">
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Current"}
                                onChange={e => {
                                  if (type === "curent") {
                                    setType("");
                                  } else {
                                    setType("current");
                                  }
                                }}
                                checked={type === "current"}
                              />
                              <span>{t(`all-application.Current`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Last 3 Months"}
                                onChange={e => {
                                  if (type === "previous") {
                                    setType("");
                                  } else {
                                    setType("previous");
                                  }
                                }}
                                checked={type === "previous"}
                              />
                              <span>{t(`all-application.Last 3 Months`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Custom"}
                                onChange={e => {
                                  if (type === "custom") {
                                    setType("");
                                  } else {
                                    setType("custom");
                                  }
                                }}
                                checked={type === "custom"}
                              />
                              <span>{t(`all-application.Custom`)}</span>
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    {type === "custom" && (
                      <>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.Start Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.Start Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setStartDate(e);
                              }}
                              placeholderText={t(`all-application.Start Date`)}
                              id="date"
                              selected={startDate}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.End Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.End Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setEndDate(e);
                              }}
                              placeholderText={t(`all-application.End Date`)}
                              id="date"
                              selected={endDate}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                  </form>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        className="btn btn-primary reset"
                        onClick={() => clearFilters()}
                      >
                        {t(`ATS View.Reset`)}
                      </button>
                      <button
                        className="btn btn-primary search"
                        onClick={() => handleSubmit()}
                      >
                        {t(`ATS View.Search`)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {isReject && (
          <div className="filter-shadow reject-people-data">
            {/* ✅ backdrop FIRST */}
            <div className="black-showd" onClick={reject_close}></div>

            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>
                    {actionType === "reject"
                      ? t("all-application.Reject Application")
                      : t("all-application.Shortlist Application")}
                  </h4>
                </div>
                <div className="filter-content cross" onClick={reject_close}>
                  <img src={cross} alt="" />
                </div>
              </div>

              <div className="reject-people data">
                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={name_icon} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Name")}</p>
                      <h4>{candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={job} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Job Role")}</p>
                      <h4>{candidateDetails.vacancy?.title}</h4>
                    </div>
                  </div>
                </div>

                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={education} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Education")}</p>
                      <h4>
                        {
                          candidateDetails.master_reference_table
                            ?.highest_qualification
                        }
                      </h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={star_exp} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Total Exp")}</p>
                      <h4>{candidateDetails.job_user?.total_experience}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-cards-form reject-data">
                <h4>
                  {actionType === "reject"
                    ? t("all-application.Reject Candidate confirmation")
                    : t("all-application.Shortlist Candidate confirmation")}
                </h4>

                <p>
                  {actionType === "reject"
                    ? t("all-application.Reject Candidate msg")
                    : t("all-application.Shortlist Candidate msg")}
                </p>

                {actionType === "reject" && (
                  <Form.Group className="form-considere mb-2">
                    <Form.Label>Rejected Remark</Form.Label>
                    <Form.Select
                      value={selectedRemark?.id || ""}
                      onChange={handleRemarkChange}
                    >
                      <option value="">Select rejection reason</option>
                      {remarks.map(r => (
                        <option key={r.id} value={r.id}>
                          {r.remark_label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}

                <form className="form-inline">
                  <div className="col-lg-12">
                    {actionType !== "reject" && (
                      <Form.Group className="form-considere">
                        <Form.Check
                          type="checkbox"
                          label="Require comment"
                          checked={isCommentRequired}
                          onChange={toggleCommentRequirement}
                        />
                      </Form.Group>
                    )}

                    <textarea
                      className="form-control"
                      rows="3"
                      name="comment"
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                      placeholder={
                        actionType === "reject"
                          ? selectedRemark?.is_comment_required
                            ? t("all-application.Reject Comment")
                            : t("all-application.Optional Comment")
                          : t("all-application.Shortlist Comment")
                      }
                    />

                    {commentError && (
                      <div className="text-danger">{commentError}</div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <a
                        href="javascript:void(0);"
                        className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={!isLoading ? handleActionSubmit : undefined}
                        style={isLoading ? { pointerEvents: "none", opacity: 0.6 } : {}}
                      >
                        {isLoading
                          ? t("all-application.Please wait...")
                          : actionType === "reject"
                          ? t("all-application.Reject")
                          : actionType === "shortlist"
                          ? t("all-application.shortlist")
                          : t("all-application.Select")}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {/* reject data popup */}

        {/* Onhold data popup */}
        {isHold && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Hold Application`)}</h4>
                </div>
                <div className="filter-content cross" onClick={hold_close}>
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="reject-people data">
                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={name_icon} alt="name icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Name`)}</p>
                      <h4>{candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={job} alt="job icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Job Role`)}</p>
                      <h4>{candidateDetails.vacancy?.title}</h4>
                    </div>
                  </div>
                </div>

                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={education} alt="education icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Education`)}</p>
                      <h4>
                        {
                          candidateDetails?.master_reference_tabl
                            ?.highest_qualification
                        }
                      </h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={star_exp} alt="star exp icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Total Exp`)}</p>
                      <h4>{candidateDetails.job_user.total_experience}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-cards-form reject-data">
                <h4>{t(`all-application.Select Candidate confirmation`)}</h4>
                <p>{t(`all-application.Select Candidate msg`)}</p>
                <form class="form-inline">
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Compulsory Comment`)}
                        rows="3"
                        name="comment"
                        onChange={handleChange}
                      ></textarea>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={() =>
                          handleConfirm(
                            candidateDetails.appl_id,
                            4,
                            comment,
                            "Onhold"
                          )
                        }
                      >
                        {t(`all-application.Hold`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}

        {isOnboard && (
          <div className="filter-shadow reject-people-data inselected selected-modal-list">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4 className="pb-1">
                    {t(`all-application.Invite for Onboarding`)}
                  </h4>
                  <p>
                    {" "}
                    {t("all-application.Invite for Onboarding msg", {
                      company: localStorage.getItem("subdomain") || "",
                    })}
                  </p>
                </div>
                <div className="filter-content cross" onClick={onboard_close}>
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="bordertops"></div>
              {/* <div className="reject-people data mt-1">
                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={name_icon} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Candidate Name`)}</p>
                      <h4>{candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={job} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Job Role`)}</p>
                      <h4>{candidateDetails.vacancy?.title}</h4>
                    </div>
                  </div>
                </div>

                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={education} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Education`)}</p>
                      <h4>
                        {
                          candidateDetails.master_reference_table
                            .highest_qualification
                        }
                      </h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={star_exp} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Total Exp`)}</p>
                      <h4>{candidateDetails.job_user.total_experience}</h4>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="reject-people data justify-content-between">
                <div className="mobile-cards align-items-center">
                  <div className="reject-perople-user">
                    <img
                      src={
                        candidateDetails?.job_user?.candidate_photo ||
                        user_icons1
                      }
                      alt="user icon"
                      className={
                        candidateDetails?.job_user?.candidate_photo
                          ? "image-upload"
                          : "iconuse"
                      }
                    />
                  </div>

                  <div className="header-plant">
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4>{candidateDetails.name}</h4>
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {
                            candidateDetails?.master_reference_table
                              ?.highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-cards-form reject-data">
                <form
                  className="form-inline"
                  onSubmit={e =>
                    handleOnboardInvite(e, candidateDetails.appl_id)
                  }
                >
                  <div className="col-lg-12 mb-2">
                    <Form.Group>
                      <Form.Label>
                        
                        {t(`all-application.Date`)}<span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        selected={formData?.board_date}
                        name="board_date"
                        onChange={date => {
                          let newFormData = JSON.parse(
                            JSON.stringify(formData)
                          );
                          newFormData.board_date = date;
                          setFormData(newFormData);
                        }}
                        minDate={new Date()}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        placeholderText={t(`all-application.Select Date`)}
                      />
                      {errors.board_date && (
                        <div className="error">{errors.board_date}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12 mb-2">
                    <Form.Group>
                      <Form.Label>
                        
                        {t(`all-application.Reporting Time`)}<span className="text-danger">*</span>
                      </Form.Label>
                      <select
                        id="board_time"
                        name="board_time"
                        className="form-select"
                        data-width="100%"
                        data-size="10"
                        title="Select Time"
                        onChange={changeHandler}
                      >
                        <option selected disabled>
                          {t(`all-application.Select Reporting Time`)}{" "}
                        </option>
                        <option value="09:00 AM">09:00 AM</option>
                        <option value="10:00 AM">10:00 AM</option>
                        <option value="11:00 AM">11:00 AM</option>
                        <option value="12:00 PM">12:00 PM</option>
                        <option value="01:00 PM">01:00 PM</option>
                        <option value="02:00 PM">02:00 PM</option>
                        <option value="03:00 PM">03:00 PM</option>
                        <option value="04:00 PM">04:00 PM</option>
                        <option value="05:00 PM">05:00 PM</option>
                        <option value="06:00 PM">06:00 PM</option>
                      </select>
                      {errors.board_time && (
                        <div className="error">{errors.board_time}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12 mb-2">
                    <Form.Group>
                      <Form.Label>
                        
                        {t(`all-application.Address`)}<span className="text-danger">*</span>
                      </Form.Label>
                      <textarea
                        name="board_addr"
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Enter Address`)}
                        rows="2"
                        onChange={changeHandler}
                      ></textarea>
                      {errors.board_addr && (
                        <div className="error">{errors.board_addr}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <Form.Group>
                      <Form.Label>
                        {t(`all-application.Required Docs`)}:
                      </Form.Label>
                      <textarea
                        name="onboard_documents"
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(
                          `all-application.Enter Required Document`
                        )}
                        rows="2"
                        onChange={changeHandler}
                      ></textarea>
                    </Form.Group>
                    {/* {errors.onboard_documents && (
                      <div className="error">{errors.onboard_documents}</div>
                    )} */}
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        type="submit"
                        className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        disabled={isLoading}
                        style={isLoading ? { opacity: 0.6 } : {}}
                      >
                        {isLoading ? t("all-application.Please wait...") : t(`all-application.Submit`)}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}
        {isComment && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Comment Application`)}</h4>
                </div>
                <div className="filter-content cross" onClick={comment_close}>
                  <img src={cross} alt="cross" />
                </div>
              </div>
              <div className="bordertops"></div>
              <div className="reject-people data justify-content-between">
                <div className="mobile-cards align-items-center">
                  <div className="reject-perople-user">
                    <img
                      src={
                        candidateDetails?.job_user?.candidate_photo ||
                        user_icons1
                      }
                      alt="user icon"
                      className={
                        candidateDetails?.job_user?.candidate_photo
                          ? "image-upload"
                          : "iconuse"
                      }
                    />
                  </div>

                  <div className="header-plant">
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4>{candidateDetails.name}</h4>
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {
                            candidateDetails?.master_reference_table
                              ?.highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-cards-form reject-data">
                <h4>{t(`all-application.Enter Comment`)}</h4>
                <p>{t(`all-application.Add Comment`)}</p>
                <form class="form-inline">
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Compulsory Comment`)}
                        rows="3"
                        name="comment"
                        onChange={handleChange}
                      ></textarea>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        class="btn btn-primary reset"
                        onClick={comment_close}
                      >
                        Reset
                      </button>
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={() =>
                          handleConfirm(candidateDetails.appl_id, 0, comment)
                        }
                      >
                        {t(`all-application.Comment`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}
        {isFeedback && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Application Feedback`)}</h4>
                </div>
                <div className="filter-content cross" onClick={feedback_close}>
                  <img src={cross} alt="ccross" />
                </div>
              </div>
              <div className="reject-people data justify-content-between">
                <div className="mobile-cards align-items-center">
                  <div className="reject-perople-user">
                    <img
                      src={
                        candidateDetails?.job_user?.candidate_photo ||
                        user_icons1
                      }
                      alt="user icon"
                      className={
                        candidateDetails?.job_user?.candidate_photo
                          ? "image-upload"
                          : "iconuse"
                      }
                    />
                  </div>

                  <div className="header-plant">
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4>{candidateDetails.name}</h4>
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {
                            candidateDetails?.master_reference_table
                              ?.highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-cards-form reject-data">
                <h4>{t(`all-application.Enter Comment`)}</h4>

                <form class="form-inline">
                  <p>{t(`all-application.Add Rating`)}</p>
                  {/* <div className="col-lg-12">
                    <Rating totalStars={5} onChange={handleChangeRating} />
                  </div> */}
                  <p>{t(`all-application.Add Comment`)}</p>
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Compulsory Comment`)}
                        rows="3"
                        name="comment"
                        onChange={handleChange}
                      ></textarea>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        class="btn btn-primary reset"
                        onClick={feedback_close}
                      >
                        Reset
                      </button>
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={() =>
                          handlefeedback(candidateDetails.appl_id, 8, comment)
                        }
                      >
                        {t(`all-application.Submit`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}
      </div>
    </>
  );
}

export default SelectedList;
